import { useContext, useCallback } from 'react';
import { MetricsContext } from '../components/MetricsProvider/MetricsContext.js';

function useSendMetrics() {
  const metrics = useContext(MetricsContext);
  if (!metrics) {
    throw new Error('useSendMetrics should be used within a MetricsProvider');
  }
  const {
    tracker,
    events
  } = metrics;
  return useCallback(event => {
    const eventName = events[event];
    if (eventName) {
      tracker.track(eventName);
    }
  }, [events, tracker]);
}

export { useSendMetrics as default };
//# sourceMappingURL=useSendMetrics.js.map
